'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var ArrowLeft = function ArrowLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowLeft"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5l-7 7 7 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h16"
  }));
};

ArrowLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowLeft.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowRight = function ArrowRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowRight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5l7 7-7 7"
  }));
};

ArrowRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowRight.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowUp = function ArrowUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowUp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20V4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11l7-7 7 7"
  }));
};

ArrowUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUp.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowDown = function ArrowDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowDown"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20V4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13l7 7 7-7"
  }));
};

ArrowDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDown.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowDownLeft = function ArrowDownLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowDownLeft"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18L18 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8v10h10"
  }));
};

ArrowDownLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDownLeft.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowUpLeft = function ArrowUpLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowUpLeft"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6l12 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6H6v10"
  }));
};

ArrowUpLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpLeft.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowUpRight = function ArrowUpRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowUpRight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6L6 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6h10v10"
  }));
};

ArrowUpRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpRight.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowDownRight = function ArrowDownRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowDownRight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18L6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18h10V8"
  }));
};

ArrowDownRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDownRight.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ChevronLeft = function ChevronLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ChevronLeft"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4l-8 8 8 8"
  }));
};

ChevronLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronLeft.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ChevronRight = function ChevronRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ChevronRight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4l8 8-8 8"
  }));
};

ChevronRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronRight.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ChevronUp = function ChevronUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ChevronUp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15l8-8 8 8"
  }));
};

ChevronUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronUp.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ChevronDown = function ChevronDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ChevronDown"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9l8 8 8-8"
  }));
};

ChevronDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronDown.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowCycle = function ArrowCycle(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowCycle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12c0 6-4.39 10-9.806 10C7.792 22 4.24 19.665 3 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 6 6.39 2 11.806 2 16.209 2 19.76 4.335 21 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17l-4-1-1 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 7l4 1 1-4"
  }));
};

ArrowCycle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowCycle.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowClockwise = function ArrowClockwise(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowClockwise"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.734 16.06a8.923 8.923 0 01-3.915 3.978 8.706 8.706 0 01-5.471.832 8.795 8.795 0 01-4.887-2.64 9.067 9.067 0 01-2.388-5.079 9.136 9.136 0 011.044-5.53 8.904 8.904 0 014.069-3.815 8.7 8.7 0 015.5-.608c1.85.401 3.366 1.313 4.62 2.755.151.16.735.806 1.22 1.781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.069 7.813l5.04.907L21 3.59"
  }));
};

ArrowClockwise.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowClockwise.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowCounterClockwise = function ArrowCounterClockwise(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowCounterClockwise"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.266 16.06a8.923 8.923 0 003.915 3.978 8.706 8.706 0 005.471.832 8.796 8.796 0 004.887-2.64 9.067 9.067 0 002.388-5.079 9.137 9.137 0 00-1.044-5.53 8.904 8.904 0 00-4.068-3.815 8.7 8.7 0 00-5.5-.608c-1.85.401-3.367 1.313-4.62 2.755-.152.16-.736.806-1.22 1.781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.931 7.813l-5.04.907L3 3.59"
  }));
};

ArrowCounterClockwise.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowCounterClockwise.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowBackThick = function ArrowBackThick(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowBackThick"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11l7-9v5c11.953 0 13.332 9.678 13 15-.502-2.685-.735-7-13-7v5l-7-9z"
  }));
};

ArrowBackThick.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowBackThick.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowBackThickFill = function ArrowBackThickFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "ArrowBackThickFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2a1 1 0 00-1.79-.614l-7 9a1 1 0 000 1.228l7 9A1 1 0 0010 20v-3.99c5.379.112 7.963 1.133 9.261 2.243 1.234 1.055 1.46 2.296 1.695 3.596l.061.335a1 1 0 001.981-.122c.171-2.748-.086-6.73-2.027-10.061C19.087 8.768 15.694 6.282 10 6.022V2z"
  }));
};

ArrowBackThickFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowBackThickFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowForwardThick = function ArrowForwardThick(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowForwardThick"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 11l-7-9v5C3.047 7 1.668 16.678 2 22c.502-2.685.735-7 13-7v5l7-9z"
  }));
};

ArrowForwardThick.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowForwardThick.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowForwardThickFill = function ArrowForwardThickFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "ArrowForwardThickFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.675 1.054a1 1 0 011.114.332l7 9a1 1 0 010 1.228l-7 9A1 1 0 0114 20v-3.99c-5.379.112-7.963 1.133-9.261 2.243-1.234 1.055-1.46 2.296-1.695 3.596l-.061.335a1 1 0 01-1.981-.122c-.172-2.748.086-6.73 2.027-10.061C4.913 8.768 8.305 6.282 14 6.022V2a1 1 0 01.675-.946z"
  }));
};

ArrowForwardThickFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowForwardThickFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Width = function Width(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Width"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12H3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16l-4-4 4-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16l4-4-4-4"
  }));
};

Width.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Width.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Height = function Height(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Height"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21V3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6l4-4 4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18l4 4 4-4"
  }));
};

Height.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Height.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Enlarge = function Enlarge(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Enlarge"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21l6.5-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.5L21 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3h6v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 15v6h6"
  }));
};

Enlarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Enlarge.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Reduce = function Reduce(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Reduce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21l7-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10l7-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10h-6V4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20v-6H4"
  }));
};

Reduce.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Reduce.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowLeftThick = function ArrowLeftThick(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowLeftThick"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12l7-9v4.99L21 8v8H10v5l-7-9z"
  }));
};

ArrowLeftThick.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowLeftThick.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowDownThick = function ArrowDownThick(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowDownThick"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21l9-7h-4.99L16 3H8v11H3l9 7z"
  }));
};

ArrowDownThick.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowDownThick.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowRightThick = function ArrowRightThick(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowRightThick"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12l-7-9v4.99L3 8v8h11v5l7-9z"
  }));
};

ArrowRightThick.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowRightThick.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowUpThick = function ArrowUpThick(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowUpThick"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3l9 7h-4.99L16 21H8V10H3l9-7z"
  }));
};

ArrowUpThick.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowUpThick.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowBack = function ArrowBack(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowBack"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5l-5 5 5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10h8c5.523 0 10 4.477 10 10v1"
  }));
};

ArrowBack.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowBack.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ArrowForward = function ArrowForward(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ArrowForward"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5l5 5-5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10h-8C7.477 10 3 14.477 3 20v1"
  }));
};

ArrowForward.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ArrowForward.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TriangleLeft = function TriangleLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TriangleLeft"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12l8-6v12l-8-6z"
  }));
};

TriangleLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TriangleLeft.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TriangleRight = function TriangleRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TriangleRight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12L9 6v12l8-6z"
  }));
};

TriangleRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TriangleRight.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TriangleUp = function TriangleUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TriangleUp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7l-6 8h12l-6-8z"
  }));
};

TriangleUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TriangleUp.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TriangleDown = function TriangleDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TriangleDown"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17L6 9h12l-6 8z"
  }));
};

TriangleDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TriangleDown.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleTriangleRight = function CircleTriangleRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleTriangleRight"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12l-6-4v8l6-4z"
  }));
};

CircleTriangleRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleTriangleRight.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleTriangleLeft = function CircleTriangleLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleTriangleLeft"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12l6-4v8l-6-4z"
  }));
};

CircleTriangleLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleTriangleLeft.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleTriangleUp = function CircleTriangleUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleTriangleUp"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8l-4 6h8l-4-6z"
  }));
};

CircleTriangleUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleTriangleUp.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleTriangleDown = function CircleTriangleDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleTriangleDown"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16l-4-6h8l-4 6z"
  }));
};

CircleTriangleDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleTriangleDown.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleChevronLeft = function CircleChevronLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleChevronLeft"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8l-4 4 4 4"
  }));
};

CircleChevronLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleChevronLeft.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleChevronRight = function CircleChevronRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleChevronRight"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8l4 4-4 4"
  }));
};

CircleChevronRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleChevronRight.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleChevronUp = function CircleChevronUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleChevronUp"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5l4-4 4 4"
  }));
};

CircleChevronUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleChevronUp.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleChevronDown = function CircleChevronDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleChevronDown"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5l4 4 4-4"
  }));
};

CircleChevronDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleChevronDown.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ChevronHorizontal = function ChevronHorizontal(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ChevronHorizontal"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8l4 4-4 4M7 8l-4 4 4 4"
  }));
};

ChevronHorizontal.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronHorizontal.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ChevronVertical = function ChevronVertical(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ChevronVertical"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7l4-4 4 4M8 17l4 4 4-4"
  }));
};

ChevronVertical.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ChevronVertical.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Plus = function Plus(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Plus"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20v-8m0 0V4m0 8h8m-8 0H4"
  }));
};

Plus.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Plus.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Minus = function Minus(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Minus"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12H4"
  }));
};

Minus.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Minus.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Cross = function Cross(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Cross"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20L4 4m16 0L4 20"
  }));
};

Cross.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Cross.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Check = function Check(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Check"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12l6 6L20 6"
  }));
};

Check.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Check.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Question = function Question(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Question"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.484C10.5 7.494 11 7 12 7c1.246 0 2 .989 2 1.978s-.5 1.483-2 2.473V13m0 3.5v.5"
  }));
};

Question.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Question.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleAlert = function CircleAlert(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleAlert"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v6m0 3.5v.5"
  }));
};

CircleAlert.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleAlert.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleX = function CircleX(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15L9 9m6 0l-6 6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};

CircleX.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleX.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleCheck = function CircleCheck(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleCheck"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5l3 3 5-6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};

CircleCheck.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleCheck.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CirclePlus = function CirclePlus(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CirclePlus"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v4m0 0v4m0-4h4m-4 0H8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};

CirclePlus.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CirclePlus.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleMinus = function CircleMinus(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CircleMinus"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12H8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};

CircleMinus.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleMinus.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TriangleAlert = function TriangleAlert(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TriangleAlert"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5v.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.232 19.016L10.35 3.052c.713-1.403 2.59-1.403 3.302 0l8.117 15.964C22.45 20.36 21.544 22 20.116 22H3.883c-1.427 0-2.334-1.64-1.65-2.984z"
  }));
};

TriangleAlert.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TriangleAlert.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Stop = function Stop(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Stop"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2L2 8.156V16l6 6h8l6-6V8.156L16 2H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12H8"
  }));
};

Stop.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Stop.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Info = function Info(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Info"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11h2v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16h4"
  }));
};

Info.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Info.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Play = function Play(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Play"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12L6 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12L6 4"
  }));
};

Play.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Play.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Pause = function Pause(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Pause"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5v14M17 5v14"
  }));
};

Pause.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Pause.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Command = function Command(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Command"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 17.85a3.15 3.15 0 11-3.15-3.15h11.7a3.15 3.15 0 11-3.15 3.15V6.15a3.15 3.15 0 113.15 3.15H6.15A3.15 3.15 0 119.3 6.15v11.7z"
  }));
};

Command.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Command.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var SoundDown = function SoundDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "SoundDown"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 00.707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 006.578 16H3c-.552 0-1-.466-1-1.041z"
  }));
};

SoundDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SoundDown.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var SoundOn = function SoundOn(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "SoundOn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5c1.333 1.778 1.333 5.222 0 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5c3.988 3.808 4.012 10.217 0 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 00.707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 006.578 16H3c-.552 0-1-.466-1-1.041z"
  }));
};

SoundOn.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SoundOn.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var SoundOff = function SoundOff(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "SoundOff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 15l-6-6m6 0l-6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 00.707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 006.578 16H3c-.552 0-1-.466-1-1.041z"
  }));
};

SoundOff.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SoundOff.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var SoundUp = function SoundUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "SoundUp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9v3m0 0v3m0-3h3m-3 0h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 00.707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 006.578 16H3c-.552 0-1-.466-1-1.041z"
  }));
};

SoundUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SoundUp.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Infinity = function Infinity(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Infinity"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.636 16C2.91 16 2 14 2 12s.91-4 3.636-4c3.637 0 9.091 8 12.728 8C21.09 16 22 14 22 12s-.91-4-3.636-4c-3.637 0-9.091 8-12.728 8z"
  }));
};

Infinity.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Infinity.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AirplayAudio = function AirplayAudio(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "AirplayAudio"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16l6 5H6l6-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18a9.956 9.956 0 01-2-6C2 6.477 6.477 2 12 2s10 4.477 10 10a9.956 9.956 0 01-2 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.123 15.125a6 6 0 10-10.247-.002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12a2 2 0 10-4 0"
  }));
};

AirplayAudio.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AirplayAudio.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AirplayVideo = function AirplayVideo(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "AirplayVideo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17H4a2 2 0 01-2-2V5a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16l6 5H6l6-5z"
  }));
};

AirplayVideo.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AirplayVideo.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Miniplayer = function Miniplayer(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Miniplayer"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "4",
    width: "20",
    height: "16",
    rx: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "13",
    y: "13",
    width: "9",
    height: "7",
    rx: "2"
  }));
};

Miniplayer.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Miniplayer.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TextAlignLeft = function TextAlignLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TextAlignLeft"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18M3 12h10M3 18h15"
  }));
};

TextAlignLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TextAlignLeft.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TextAlignCenter = function TextAlignCenter(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TextAlignCenter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18M7 12h10M5 18h14"
  }));
};

TextAlignCenter.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TextAlignCenter.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TextAlignRight = function TextAlignRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TextAlignRight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18m-10 6h10M6 18h15"
  }));
};

TextAlignRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TextAlignRight.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TextAlignJustified = function TextAlignJustified(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TextAlignJustified"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18M3 12h18M3 18h18"
  }));
};

TextAlignJustified.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TextAlignJustified.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Mention = function Mention(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Mention"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10c2.252 0 4.33-.744 6.001-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8v4c0 1 .6 3 3 3s3-2 3-3"
  }));
};

Mention.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Mention.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Heart = function Heart(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Heart"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3C4.239 3 2 5.216 2 7.95c0 2.207.875 7.445 9.488 12.74a.985.985 0 001.024 0C21.125 15.395 22 10.157 22 7.95 22 5.216 19.761 3 17 3s-5 3-5 3-2.239-3-5-3z"
  }));
};

Heart.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Heart.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var FullScreen = function FullScreen(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "FullScreen"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7V2h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 7V2h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 22H2v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22h5v-5"
  }));
};

FullScreen.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FullScreen.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var NormalScreen = function NormalScreen(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "NormalScreen"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 2v5H2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 2v5h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 17h5v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 17h-5v5"
  }));
};

NormalScreen.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
NormalScreen.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AlignLeft = function AlignLeft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "AlignLeft"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2v20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "6",
    width: "16",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "14",
    width: "10",
    height: "4"
  }));
};

AlignLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlignLeft.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AlignHorizontalCenter = function AlignHorizontalCenter(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "AlignHorizontalCenter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2v20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10H4V6h4m8 0h4v4h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14H6v4h2m8-4h2v4h-2"
  }));
};

AlignHorizontalCenter.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlignHorizontalCenter.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AlignRight = function AlignRight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "AlignRight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 2v20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "6",
    width: "16",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "8",
    y: "14",
    width: "10",
    height: "4"
  }));
};

AlignRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlignRight.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AlignTop = function AlignTop(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "AlignTop"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 2H2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 22V6h4v16H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16V6h4v10h-4z"
  }));
};

AlignTop.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlignTop.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AlignVerticalCenter = function AlignVerticalCenter(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "AlignVerticalCenter"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12H2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8V4H6v4m0 8v4h4v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8V6h4v2m-4 8v2h4v-2"
  }));
};

AlignVerticalCenter.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlignVerticalCenter.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AlignBottom = function AlignBottom(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "AlignBottom"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 22H2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18V2h4v16H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 18V8h4v10h-4z"
  }));
};

AlignBottom.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlignBottom.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ShareBox = function ShareBox(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ShareBox"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v12m0-12L8 7m4-4l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 17l.621 2.485A2 2 0 004.561 21H19.439a2 2 0 001.94-1.515L22 17"
  }));
};

ShareBox.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ShareBox.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Download = function Download(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Download"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15V3m0 12l-4-4m4 4l4-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 17l.621 2.485A2 2 0 004.561 21H19.439a2 2 0 001.94-1.515L22 17"
  }));
};

Download.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Download.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AlignToTop = function AlignToTop(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "AlignToTop"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22V7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14l7-7 7 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2h20"
  }));
};

AlignToTop.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlignToTop.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AlignToMiddle = function AlignToMiddle(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "AlignToMiddle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12H2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5l3 3 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 19l3-3 3 3"
  }));
};

AlignToMiddle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlignToMiddle.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AlignToBottom = function AlignToBottom(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "AlignToBottom"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 22h20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2v15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10l7 7 7-7"
  }));
};

AlignToBottom.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AlignToBottom.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Block = function Block(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Block"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19L19 5"
  }));
};

Block.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Block.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var MoreHorizontal = function MoreHorizontal(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "MoreHorizontal"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "12",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "12",
    r: "1"
  }));
};

MoreHorizontal.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
MoreHorizontal.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var MoreVertical = function MoreVertical(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "MoreVertical"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "4",
    r: "1",
    transform: "rotate(90 12 4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "1",
    transform: "rotate(90 12 12)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "20",
    r: "1",
    transform: "rotate(90 12 20)"
  }));
};

MoreVertical.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
MoreVertical.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Wifi = function Wifi(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Wifi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 10c6-6.667 14-6.667 20 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14c3.6-4 8.4-4 12 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "18",
    r: "1"
  }));
};

Wifi.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Wifi.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Bluetooth = function Bluetooth(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Bluetooth"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7l12 10-6 5V2l6 5L5 17"
  }));
};

Bluetooth.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Bluetooth.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Location = function Location(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Location"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "10",
    r: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a8 8 0 00-8 8c0 1.892.402 3.13 1.5 4.5L12 22l6.5-7.5c1.098-1.37 1.5-2.608 1.5-4.5a8 8 0 00-8-8z"
  }));
};

Location.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Location.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var LinkChain = function LinkChain(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "LinkChain"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.544 10.456a4.368 4.368 0 00-6.176 0l-3.089 3.088a4.367 4.367 0 106.177 6.177L12 18.177m-1.544-4.633a4.368 4.368 0 006.177 0l3.088-3.088a4.368 4.368 0 00-6.177-6.177L12 5.823"
  }));
};

LinkChain.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LinkChain.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var LinkOut = function LinkOut(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "LinkOut"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.5L21 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3h5v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14v5a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h5"
  }));
};

LinkOut.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LinkOut.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var SignOut = function SignOut(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "SignOut"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12h9m0 0l-3.333-4M22 12l-3.333 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7V5.174a2 2 0 00-2.166-1.993l-8 .666A2 2 0 002 5.84v12.32a2 2 0 001.834 1.993l8 .667A2 2 0 0014 18.826V17"
  }));
};

SignOut.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SignOut.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Hashtag = function Hashtag(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Hashtag"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3L6 21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3l-4 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8h17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16h17"
  }));
};

Hashtag.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Hashtag.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Grid = function Grid(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Grid"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "3",
    width: "7",
    height: "7",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "14",
    width: "7",
    height: "7",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "3",
    width: "7",
    height: "7",
    rx: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "14",
    width: "7",
    height: "7",
    rx: "1"
  }));
};

Grid.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Grid.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var LinkOn = function LinkOn(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "LinkOn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6h1a6 6 0 016 6v0a6 6 0 01-6 6h-1m-6 0H8a6 6 0 01-6-6v0a6 6 0 016-6h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12h6"
  }));
};

LinkOn.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LinkOn.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var LinkOff = function LinkOff(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "LinkOff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6h1a6 6 0 016 6v0a6 6 0 01-6 6h-1m-6 0H8a6 6 0 01-6-6v0a6 6 0 016-6h1"
  }));
};

LinkOff.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LinkOff.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Water = function Water(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Water"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22a8 8 0 01-8-8c0-3.502 2.71-6.303 5.093-8.87L12 2l2.907 3.13C17.29 7.698 20 10.499 20 14a8 8 0 01-8 8z"
  }));
};

Water.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Water.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Fire = function Fire(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Fire"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22c-4.418 0-8-2.582-8-7v-.088C4 12.794 5.189 11.1 7 10c1.732-1.052 2.757-2.99 2.5-5L9 2l1.854.795a16.705 16.705 0 017.924 7.066A9.277 9.277 0 0120 14.464V15c0 1.562-.448 2.895-1.222 3.965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22c-1.657 0-3-1.433-3-3.2 0-1.4 1.016-2.521 1.91-3.548L12 14l1.09 1.252C13.984 16.28 15 17.4 15 18.8c0 1.767-1.343 3.2-3 3.2z"
  }));
};

Fire.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Fire.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Air = function Air(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Air"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8h7a3 3 0 10-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16h11a3 3 0 11-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12h17a3 3 0 10-3-3"
  }));
};

Air.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Air.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Comment = function Comment(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Comment"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
  }));
};

Comment.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Comment.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CommentAdd = function CommentAdd(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CommentAdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v3m0 0v3m0-3h3m-3 0H9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
  }));
};

CommentAdd.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CommentAdd.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ZoomIn = function ZoomIn(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ZoomIn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7v3.5m0 0V14m0-3.5H14m-3.5 0H7"
  }));
};

ZoomIn.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ZoomIn.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ZoomOut = function ZoomOut(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ZoomOut"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10.5H8"
  }));
};

ZoomOut.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ZoomOut.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Health = function Health(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Health"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3a1 1 0 00-1-1H9a1 1 0 00-1 1v5H3a1 1 0 00-1 1v6a1 1 0 001 1h5v5a1 1 0 001 1h6a1 1 0 001-1v-5h5a1 1 0 001-1V9a1 1 0 00-1-1h-5V3z"
  }));
};

Health.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Health.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Rss = function Rss(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Rss"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.03C14.114 3.5 20.501 9.887 19.97 20M4 10.418c6.068-.319 9.9 3.514 9.582 9.582"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "19",
    r: "1"
  }));
};

Rss.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Rss.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Circle = function Circle(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Circle"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }));
};

Circle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Circle.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CircleFill = function CircleFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "CircleFill"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }));
};

CircleFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CircleFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Backspace = function Backspace(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Backspace"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15l-6-6m6 0l-6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4 4.8A2 2 0 019 4h11a2 2 0 012 2v12a2 2 0 01-2 2H9a2 2 0 01-1.6-.8l-4.5-6a2 2 0 010-2.4l4.5-6z"
  }));
};

Backspace.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Backspace.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var BackspaceFill = function BackspaceFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "BackspaceFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6 4.2A3 3 0 019 3h11a3 3 0 013 3v12a3 3 0 01-3 3H9a3 3 0 01-2.4-1.2l-4.5-6a3 3 0 010-3.6l4.5-6zm11.107 5.507a1 1 0 00-1.414-1.414L14 10.586l-2.293-2.293a1 1 0 10-1.414 1.414L12.586 12l-2.293 2.293a1 1 0 001.414 1.414L14 13.414l2.293 2.293a1 1 0 001.414-1.414L15.414 12l2.293-2.293z"
  }));
};

BackspaceFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BackspaceFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var DoubleCheck = function DoubleCheck(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "DoubleCheck"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12l5.25 5 2.625-3M16 7l-3.5 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12l5.25 5L22 7"
  }));
};

DoubleCheck.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
DoubleCheck.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Ribbon = function Ribbon(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Ribbon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5v14.586c0 .89 1.077 1.337 1.707.707L12 14l6.293 6.293c.63.63 1.707.184 1.707-.707V5a2 2 0 00-2-2H6a2 2 0 00-2 2z"
  }));
};

Ribbon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Ribbon.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Phone = function Phone(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Phone"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.554 6.24L7.171 2.335c-.39-.45-1.105-.448-1.558.006L2.831 5.128c-.828.829-1.065 2.06-.586 3.047a29.207 29.207 0 0013.561 13.58c.986.479 2.216.242 3.044-.587l2.808-2.813c.455-.455.456-1.174.002-1.564l-3.92-3.365c-.41-.352-1.047-.306-1.458.106l-1.364 1.366a.462.462 0 01-.553.088 14.557 14.557 0 01-5.36-5.367.463.463 0 01.088-.554l1.36-1.361c.412-.414.457-1.054.101-1.465z"
  }));
};

Phone.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Phone.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Attach = function Attach(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Attach"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.91V16a6 6 0 006 6v0a6 6 0 006-6V6a4 4 0 00-4-4v0a4 4 0 00-4 4v9.182a2 2 0 002 2v0a2 2 0 002-2V8"
  }));
};

Attach.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Attach.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Thunder = function Thunder(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Thunder"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.79 3.603A1 1 0 0016.99 2H10.58a1 1 0 00-.867.502l-4.853 8.456a1 1 0 00.868 1.497H9L5.916 20.52c-.445 1.02.76 1.953 1.57 1.215L20 9.331h-6.539l4.328-5.728z"
  }));
};

Thunder.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Thunder.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Send = function Send(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Send"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.912 12H4L2.023 4.135A.662.662 0 012 3.995c-.022-.721.772-1.221 1.46-.891L22 12 3.46 20.896c-.68.327-1.464-.159-1.46-.867a.66.66 0 01.033-.186L3.5 15"
  }));
};

Send.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Send.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Sun = function Sun(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Sun"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3V2m0 20v-1m9-9h1M2 12h1m16-7l1-1M4 20l1-1M4 4l1 1m14 14l1 1m-2-8a6 6 0 11-12 0 6 6 0 0112 0z"
  }));
};

Sun.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Sun.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Moon = function Moon(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Moon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.958 15.325c.204-.486-.379-.9-.868-.684a7.684 7.684 0 01-3.101.648c-4.185 0-7.577-3.324-7.577-7.425a7.28 7.28 0 011.134-3.91c.284-.448-.057-1.068-.577-.936C5.96 4.041 3 7.613 3 11.862 3 16.909 7.175 21 12.326 21c3.9 0 7.24-2.345 8.632-5.675z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.611 3.103c-.53-.354-1.162.278-.809.808l.63.945a2.332 2.332 0 010 2.588l-.63.945c-.353.53.28 1.162.81.808l.944-.63a2.332 2.332 0 012.588 0l.945.63c.53.354 1.162-.278.808-.808l-.63-.945a2.332 2.332 0 010-2.588l.63-.945c.354-.53-.278-1.162-.809-.808l-.944.63a2.332 2.332 0 01-2.588 0l-.945-.63z"
  }));
};

Moon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Moon.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Pencil = function Pencil(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Pencil"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.333 16.048L16.57 3.81a2.56 2.56 0 013.62 3.619L7.951 19.667a2 2 0 01-1.022.547L3 21l.786-3.93a2 2 0 01.547-1.022z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.5l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.5l3 3"
  }));
};

Pencil.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Pencil.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Pin = function Pin(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Pin"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.115 2h-8.23C6.97 2 6.2 2.572 6.086 3.333L6 4c-.08.539.174.985.584 1.363.125.115.251.23.375.347.776.732.85 1.858.508 2.869l-.429 1.269a2.948 2.948 0 01-.09.3c-.099.269-.33.862-.63 1.379-.19.327-.478.58-.793.79-.756.504-.4 1.683.51 1.683H10.5v2.111c0 1.242-.21 2.467.345 3.578L12 22l1.155-2.31c.556-1.112.345-2.337.345-3.579V14h4.465c.91 0 1.266-1.18.51-1.684-.315-.21-.603-.462-.793-.79a9.33 9.33 0 01-.63-1.379 2.97 2.97 0 01-.09-.3l-.429-1.269c-.34-1.01-.267-2.136.508-2.868.124-.117.25-.232.375-.347.41-.378.664-.824.584-1.363l-.086-.667C17.8 2.572 17.029 2 16.115 2z"
  }));
};

Pin.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Pin.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Star = function Star(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Star"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.074 2.633c.32-.844 1.531-.844 1.852 0l2.07 5.734c.145.38.514.633.926.633h5.087c.94 0 1.35 1.17.611 1.743L18 14a.968.968 0 00-.322 1.092L19 20.695c.322.9-.72 1.673-1.508 1.119l-4.917-3.12a1 1 0 00-1.15 0l-4.917 3.12c-.787.554-1.83-.22-1.508-1.119l1.322-5.603A.968.968 0 006 14l-3.62-3.257C1.64 10.17 2.052 9 2.99 9h5.087a.989.989 0 00.926-.633l2.07-5.734z"
  }));
};

Star.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Star.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Draft = function Draft(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Draft"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18v2a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h2m5.5-1v4H16m-1.315-8H10a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.242a2 2 0 00-.602-1.43L16.083 2.57A2 2 0 0014.685 2z"
  }));
};

Draft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Draft.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var EyeOpen = function EyeOpen(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "EyeOpen"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.257 10.962c.474.62.474 1.457 0 2.076C19.764 14.987 16.182 19 12 19c-4.182 0-7.764-4.013-9.257-5.962a1.692 1.692 0 010-2.076C4.236 9.013 7.818 5 12 5c4.182 0 7.764 4.013 9.257 5.962z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }));
};

EyeOpen.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
EyeOpen.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var EyeClosed = function EyeClosed(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "EyeClosed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.124 11.309a.842.842 0 010 1.382C19.559 13.836 16.062 16 12 16s-7.559-2.164-9.124-3.309a.842.842 0 010-1.382C4.441 10.164 7.938 8 12 8s7.559 2.164 9.124 3.309z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 14l2 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15.5l1 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18.5l1-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14l-2 2.5"
  }));
};

EyeClosed.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
EyeClosed.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Airpods = function Airpods(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Airpods"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6c0 2.21 1.644 4 4 4s4-1.79 4-4-1.644-4-4-4-4 1.79-4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6c0 2.21-1.644 4-4 4S2 8.21 2 6s1.644-4 4-4 4 1.79 4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6v14a2 2 0 002 2v0a2 2 0 002-2V10.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6v14a2 2 0 01-2 2v0a2 2 0 01-2-2V10.57"
  }), /*#__PURE__*/React.createElement("line", {
    y1: "-1",
    x2: "3",
    y2: "-1",
    transform: "matrix(-1 0 0 1 17 19)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "7",
    y1: "18",
    x2: "10",
    y2: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3v0a5.408 5.408 0 000 6v0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3v0a5.408 5.408 0 010 6v0"
  }));
};

Airpods.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Airpods.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Paper = function Paper(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Paper"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v16a2 2 0 002 2h12a2 2 0 002-2V8.342a2 2 0 00-.602-1.43l-4.44-4.342A2 2 0 0013.56 2H6a2 2 0 00-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4a2 2 0 002 2h4"
  }));
};

Paper.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Paper.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var File = function File(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "File"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v16a2 2 0 002 2h12a2 2 0 002-2V8.342a2 2 0 00-.602-1.43l-4.44-4.342A2 2 0 0013.56 2H6a2 2 0 00-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2v4a2 2 0 002 2h4"
  }));
};

File.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
File.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Headphone = function Headphone(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Headphone"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 13.565C2 11.512 4 11 6 11v9a4 4 0 01-4-4v-2.435z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 13.565C22 11.512 20 11 18 11v9a4 4 0 004-4v-2.435z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20V10a6 6 0 1112 0v10"
  }));
};

Headphone.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Headphone.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var MobileDevice = function MobileDevice(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "MobileDevice"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "2",
    width: "12",
    height: "20",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.95 19h.1"
  }));
};

MobileDevice.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
MobileDevice.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TabletDevice = function TabletDevice(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TabletDevice"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "4",
    y: "2",
    width: "16",
    height: "20",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19h2"
  }));
};

TabletDevice.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TabletDevice.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var LaptopDevice = function LaptopDevice(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "LaptopDevice"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7a2 2 0 012-2h12a2 2 0 012 2v9H4V7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 19h20"
  }));
};

LaptopDevice.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LaptopDevice.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var DesktopDevice = function DesktopDevice(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "DesktopDevice"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6a2 2 0 012-2h16a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20h8"
  }));
};

DesktopDevice.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
DesktopDevice.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var WatchDevice = function WatchDevice(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "WatchDevice"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H7a2 2 0 01-2-2V7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 2h6"
  }));
};

WatchDevice.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
WatchDevice.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Wallet = function Wallet(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Wallet"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 8h20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12h7c0 1 .6 3 3 3s3-2 3-3h7"
  }));
};

Wallet.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Wallet.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Search = function Search(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Search"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z"
  }));
};

Search.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Search.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var LockOn = function LockOn(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "LockOn"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "10",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6a3 3 0 013-3h6a3 3 0 013 3v4H6V6z"
  }));
};

LockOn.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LockOn.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var LockOff = function LockOff(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "LockOff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "10",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10V5a3 3 0 013-3h6a3 3 0 013 3v1"
  }));
};

LockOff.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LockOff.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Camera = function Camera(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Camera"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.233 5.834l.445-2.226A2 2 0 018.64 2h6.72a2 2 0 011.962 1.608l.445 2.226a1.879 1.879 0 001.387 1.454A3.758 3.758 0 0122 10.934V18a4 4 0 01-4 4H6a4 4 0 01-4-4v-7.066a3.758 3.758 0 012.846-3.646 1.879 1.879 0 001.387-1.454z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "14",
    r: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h2"
  }));
};

Camera.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Camera.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Image = function Image(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Image"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6a4 4 0 014-4h12a4 4 0 014 4v12a4 4 0 01-4 4H6a4 4 0 01-4-4V6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8.5",
    cy: "8.5",
    r: "2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.526 12.621L6 22h12.27A3.73 3.73 0 0022 18.27c0-.466-.175-.915-.49-1.26l-4.03-4.395a2 2 0 00-2.954.006z"
  }));
};

Image.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Image.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Folder = function Folder(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Folder"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19V9a2 2 0 00-2-2h-6.764a2 2 0 01-1.789-1.106l-.894-1.788A2 2 0 008.763 3H4a2 2 0 00-2 2v14a2 2 0 002 2h16a2 2 0 002-2z"
  }));
};

Folder.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Folder.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var FolderAdd = function FolderAdd(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "FolderAdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19V9a2 2 0 00-2-2h-6.764a2 2 0 01-1.789-1.106l-.894-1.788A2 2 0 008.763 3H4a2 2 0 00-2 2v14a2 2 0 002 2h16a2 2 0 002-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11v3m0 0v3m0-3h3m-3 0H9"
  }));
};

FolderAdd.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FolderAdd.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Calendar = function Calendar(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Calendar"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "4",
    width: "20",
    height: "18",
    rx: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 10h20"
  }));
};

Calendar.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Calendar.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Bell = function Bell(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Bell"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.721 3.003L11.255 3c-3.344-.008-6.247 2.709-6.27 6v5.79c0 .79-.1 1.561-.531 2.218l-.287.438C3.73 18.11 4.2 19 4.985 19h14.03c.785 0 1.254-.89.818-1.554l-.287-.438c-.43-.657-.531-1.429-.531-2.219V9.001c-.04-3.292-2.95-5.99-6.294-5.998z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19a3 3 0 11-6 0"
  }));
};

Bell.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Bell.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Home = function Home(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Home"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 20v-7.826a4 4 0 00-1.253-2.908l-7.373-6.968a2 2 0 00-2.748 0L3.253 9.266A4 4 0 002 12.174V20a2 2 0 002 2h16a2 2 0 002-2z"
  }));
};

Home.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Home.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var BatteryLow = function BatteryLow(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "BatteryLow"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "6",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10h1.5a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H20v-4z"
  }));
};

BatteryLow.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BatteryLow.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var BatteryMedium = function BatteryMedium(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "BatteryMedium"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "6",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10h1.5a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H20v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10v4"
  }));
};

BatteryMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BatteryMedium.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var BatteryFull = function BatteryFull(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "BatteryFull"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "6",
    width: "18",
    height: "12",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10h1.5a.5.5 0 01.5.5v3a.5.5 0 01-.5.5H20v-4z"
  }));
};

BatteryFull.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BatteryFull.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Flashlight = function Flashlight(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Flashlight"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4v1c0 1.636 2 4 3 5l.75 9.01A3.26 3.26 0 0012 22v0a3.26 3.26 0 003.25-2.99L16 10c1-1 3-3.364 3-5V4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11v2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "12",
    cy: "4",
    rx: "7",
    ry: "2"
  }));
};

Flashlight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Flashlight.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Calculator = function Calculator(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Calculator"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6a4 4 0 014-4h12a4 4 0 014 4v5H2V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 16.5h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11h10v7a4 4 0 01-4 4h-6V11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11H2v7a4 4 0 004 4h6V11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18L7 16.5m0 0L8.5 15M7 16.5L8.5 18M7 16.5L5.5 15"
  }));
};

Calculator.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Calculator.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Alarm = function Alarm(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Alarm"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "13",
    r: "9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.5L12 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19l1 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19l-1 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5l3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 2l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4V2"
  }));
};

Alarm.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Alarm.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Globe = function Globe(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Globe"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "12",
    cy: "12",
    rx: "10",
    ry: "3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "12",
    cy: "12",
    rx: "10",
    ry: "5",
    transform: "rotate(90 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2v20"
  }));
};

Globe.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Globe.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Book = function Book(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Book"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6s1.5-2 5-2 5 2 5 2v14s-1.5-1-5-1-5 1-5 1V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6s1.5-2 5-2 5 2 5 2v14s-1.5-1-5-1-5 1-5 1V6z"
  }));
};

Book.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Book.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Cloud = function Cloud(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Cloud"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.83 9.138A5 5 0 1117 19H6a4 4 0 01-.966-7.883m10.796-1.98a5.5 5.5 0 00-10.796 1.98m10.796-1.98L14.5 9.5m-9.466 1.617S5.188 12 5.5 12.5"
  }));
};

Cloud.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Cloud.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Envelope = function Envelope(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Envelope"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5l6.343 5.638a4 4 0 005.315 0L21 5"
  }));
};

Envelope.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Envelope.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ShoppingBag = function ShoppingBag(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ShoppingBag"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.051 8.92A1 1 0 015.048 8h13.904a1 1 0 01.997.92l.877 10.92A2 2 0 0118.833 22H5.167a2 2 0 01-1.993-2.16L4.05 8.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11V6a4 4 0 00-4-4v0a4 4 0 00-4 4v5"
  }));
};

ShoppingBag.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ShoppingBag.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Gift = function Gift(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Gift"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "8",
    width: "18",
    height: "14",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5a3 3 0 10-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8a3 3 0 10-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15H3"
  }));
};

Gift.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Gift.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Map = function Map(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Map"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.405 4.83L4.55 3.728A2 2 0 002 5.651v11.84a2 2 0 001.45 1.923l4.955 1.416a2 2 0 001.182-.026l4.826-1.608a2 2 0 011.182-.026l3.856 1.102A2 2 0 0022 18.349V6.509a2 2 0 00-1.45-1.923L15.594 3.17a2 2 0 00-1.182.026L9.587 4.804a2 2 0 01-1.182.026z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5v16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3v16"
  }));
};

Map.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Map.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Shield = function Shield(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Shield"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.573 21.599l2.243-1.57a13.393 13.393 0 005.448-13.624.837.837 0 00-.453-.586L12 2 4.19 5.819a.837.837 0 00-.454.586 13.393 13.393 0 005.448 13.624l2.243 1.57a1 1 0 001.146 0z"
  }));
};

Shield.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Shield.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Tag = function Tag(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Tag"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.244 21.366a2.164 2.164 0 01-3.061 0l-8.549-8.549A2.164 2.164 0 013 11.287V5.163C3 3.97 3.97 3 5.164 3h6.123c.573 0 1.124.228 1.53.634l8.549 8.549a2.164 2.164 0 010 3.061l-6.122 6.122z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5L7 7"
  }));
};

Tag.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Tag.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CloudDownload = function CloudDownload(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CloudDownload"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16a5 5 0 10-1.17-9.862m0 0a5.5 5.5 0 00-10.796 1.98m10.796-1.98L14.5 6.5M5.034 8.117A4.002 4.002 0 006 16h1M5.034 8.117S5.188 9 5.5 9.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22V12m0 10l-3-3m3 3l3-3"
  }));
};

CloudDownload.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CloudDownload.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CloudUpload = function CloudUpload(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CloudUpload"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17a5 5 0 10-1.17-9.862m0 0a5.5 5.5 0 00-10.796 1.98m10.796-1.98L14.5 7.5M5.034 9.117A4.002 4.002 0 006 17h1M5.034 9.117S5.188 10 5.5 10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11v10m0-10l-3 3m3-3l3 3"
  }));
};

CloudUpload.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CloudUpload.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Gear = function Gear(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Gear"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.269C14 2.568 13.432 2 12.731 2H11.27C10.568 2 10 2.568 10 3.269v0c0 .578-.396 1.074-.935 1.286-.085.034-.17.07-.253.106-.531.23-1.162.16-1.572-.249v0a1.269 1.269 0 00-1.794 0L4.412 5.446a1.269 1.269 0 000 1.794v0c.41.41.48 1.04.248 1.572a7.946 7.946 0 00-.105.253c-.212.539-.708.935-1.286.935v0C2.568 10 2 10.568 2 11.269v1.462C2 13.432 2.568 14 3.269 14v0c.578 0 1.074.396 1.286.935.034.085.07.17.105.253.231.531.161 1.162-.248 1.572v0a1.269 1.269 0 000 1.794l1.034 1.034a1.269 1.269 0 001.794 0v0c.41-.41 1.04-.48 1.572-.249.083.037.168.072.253.106.539.212.935.708.935 1.286v0c0 .701.568 1.269 1.269 1.269h1.462c.701 0 1.269-.568 1.269-1.269v0c0-.578.396-1.074.935-1.287.085-.033.17-.068.253-.104.531-.232 1.162-.161 1.571.248v0a1.269 1.269 0 001.795 0l1.034-1.034a1.269 1.269 0 000-1.794v0c-.41-.41-.48-1.04-.249-1.572.037-.083.072-.168.106-.253.212-.539.708-.935 1.286-.935v0c.701 0 1.269-.568 1.269-1.269V11.27c0-.701-.568-1.269-1.269-1.269v0c-.578 0-1.074-.396-1.287-.935a7.755 7.755 0 00-.105-.253c-.23-.531-.16-1.162.249-1.572v0a1.269 1.269 0 000-1.794l-1.034-1.034a1.269 1.269 0 00-1.794 0v0c-.41.41-1.04.48-1.572.249a7.913 7.913 0 00-.253-.106C14.396 4.343 14 3.847 14 3.27v0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12a4 4 0 11-8 0 4 4 0 018 0z"
  }));
};

Gear.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Gear.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Flag = function Flag(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Flag"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15h13.865a1 1 0 00.768-1.64L15 9l3.633-4.36A1 1 0 0017.865 3H4v18"
  }));
};

Flag.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Flag.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Ticket = function Ticket(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Ticket"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.707 3.293c-.39.39-.369 1.021-.138 1.523a2.83 2.83 0 01-3.753 3.753c-.502-.23-1.133-.252-1.523.138l-.586.586a1 1 0 000 1.414l10.586 10.586a1 1 0 001.414 0l.586-.586c.39-.39.369-1.021.138-1.523a2.83 2.83 0 013.753-3.753c.502.23 1.133.252 1.523-.138l.586-.586a1 1 0 000-1.414L10.707 2.707a1 1 0 00-1.414 0l-.586.586z"
  }));
};

Ticket.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Ticket.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Bug = function Bug(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Bug"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9a2 2 0 012-2h10a2 2 0 012 2v5a7 7 0 01-7 7v0a7 7 0 01-7-7V9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6v-.425c0-.981.384-1.96 1.326-2.238 1.525-.45 3.823-.45 5.348 0C15.616 3.615 16 4.594 16 5.575V6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7.5L22 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.5L2 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18l-4 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12H1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12H19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18l4 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13v8"
  }));
};

Bug.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Bug.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Copy = function Copy(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18v2a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h2m6.685-5H10a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.242a2 2 0 00-.602-1.43L16.083 2.57A2 2 0 0014.685 2z"
  }));
};

Copy.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Copy.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Lifesaver = function Lifesaver(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Lifesaver"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    transform: "rotate(45 12 12)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "4",
    transform: "rotate(45 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.071 4.929l-4.243 4.243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.172 14.828l-4.243 4.243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.071 19.071l-4.243-4.243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.172 9.172L4.929 4.929"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }))));
};

Lifesaver.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Lifesaver.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Trophy = function Trophy(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Trophy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4a2 2 0 012-2h10a2 2 0 012 2v5a7 7 0 01-7 7v0a7 7 0 01-7-7V4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22h6l-3-5-3 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4H4a2 2 0 00-2 2v1.239a4 4 0 002.128 3.535L5.5 11.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4h1a2 2 0 012 2v.637a5 5 0 01-2.66 4.419l-.84.444"
  }));
};

Trophy.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Trophy.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Leaf = function Leaf(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Leaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18C19.954 18 20.917 7.83 20.994 2.997a.983.983 0 00-1.006-.988C3 2.321 3 10.557 3 18v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18s0-6 8-7"
  }));
};

Leaf.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Leaf.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Schedule = function Schedule(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Schedule"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20H6a4 4 0 01-4-4V7a4 4 0 014-4h11a4 4 0 014 4v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 8h19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15.643l-1.5 1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "17",
    r: "5"
  }));
};

Schedule.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Schedule.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Money = function Money(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Money"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 7a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9v0a4 4 0 004-4v0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19v0a4 4 0 014-4v0"
  }));
};

Money.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Money.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Scissor = function Scissor(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Scissor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.252 18.459C7.462 19.764 7.107 21 5.7 21 4.209 21 3 19.757 3 18.223s1.209-2.778 2.7-2.778c1.4 0 2.55 1.095 2.686 2.498a.846.846 0 01-.134.515zm0 0l1.948-3.476m5.548 3.476C16.538 19.764 16.893 21 18.3 21c1.491 0 2.7-1.243 2.7-2.777s-1.209-2.778-2.7-2.778c-1.4 0-2.55 1.095-2.687 2.498-.017.182.04.36.135.515zm0 0L7.093 3.346a.659.659 0 00-1.1-.081c-1.704 2.19-1.534 5.35.395 7.333L7.5 11.742m4.45.086l4.954-8.493a.66.66 0 011.098-.076c1.707 2.194 1.537 5.358-.395 7.345L16.5 11.742"
  }));
};

Scissor.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Scissor.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Coin = function Coin(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Coin"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: "8.5",
    ry: "9",
    transform: "matrix(-1 0 0 1 10.5 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.8a3.583 3.583 0 00-2.25-.8C8.679 8 7 9.79 7 12s1.679 4 3.75 4c.844 0 1.623-.298 2.25-.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 3c3.667 0 11 .9 11 9s-7.333 9-11 9"
  }));
};

Coin.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Coin.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Telescope = function Telescope(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Telescope"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21l6-8 8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.228 7.303l13.532-5.06a1 1 0 011.108.285l.19.22A8 8 0 0122 7.973v.616a1 1 0 01-.65.937l-13.536 5.06-2.586-7.283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66 11.371a2 2 0 011.193-2.545l1.694-.624 1.944 5.473-1.64.612a2 2 0 01-2.585-1.205l-.606-1.711z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13v9"
  }));
};

Telescope.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Telescope.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Planet = function Planet(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Planet"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.399 4.849C5.372 2.582 2.972 1.489 2.23 2.23c-1.174 1.174 2.248 6.5 7.643 11.895 5.396 5.395 10.722 8.817 11.895 7.643.431-.43.243-1.421-.435-2.769"
  }));
};

Planet.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Planet.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var GameController = function GameController(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "GameController"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15l-2.968 2.968A2.362 2.362 0 012 16.298V15l1.357-6.784A4 4 0 017.279 5h9.442a4 4 0 013.922 3.216L22 15v1.297a2.362 2.362 0 01-4.032 1.67L15 15H9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5l1 2h4l1-2"
  }));
};

GameController.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
GameController.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var VrAr = function VrAr(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "VrAr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 10a2 2 0 012-2h16a2 2 0 012 2v7a2 2 0 01-2 2h-3.868a2 2 0 01-1.715-.971l-1.56-2.6a1 1 0 00-1.714 0l-1.56 2.6A2 2 0 017.868 19H4a2 2 0 01-2-2v-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.813 6.781A4 4 0 017.14 5h9.718a4 4 0 013.328 1.781L21 8H3l.813-1.219z"
  }));
};

VrAr.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
VrAr.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Computing = function Computing(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Computing"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "5",
    y: "5",
    width: "14",
    height: "14",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5V2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5V3l1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8H2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 8h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16H3l-1 1"
  }));
};

Computing.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Computing.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Inbox = function Inbox(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Inbox"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.304 6.132A4 4 0 017.209 3h9.582a4 4 0 013.905 3.132l.147.662a23.997 23.997 0 010 10.412l-.147.662A4 4 0 0116.791 21H7.21a4 4 0 01-3.905-3.132l-.147-.662a24 24 0 010-10.412l.147-.662z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13h6.338c0 1 .973 3 3.405 3 2.433 0 3.406-2 3.406-3H21.5"
  }));
};

Inbox.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Inbox.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var LightBulb = function LightBulb(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "LightBulb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 22h4M5 9a7 7 0 0114 0 6.972 6.972 0 01-3 5.734l-.542 2.566a2 2 0 01-1.977 1.7h-2.962a2 2 0 01-1.977-1.7L8 14.745A6.992 6.992 0 015 9z"
  }));
};

LightBulb.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LightBulb.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Chess = function Chess(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Chess"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.533 3.81L8 2l1 4-5.37 4.475A1.75 1.75 0 003 11.82v0c0 .617.537 1.088 1.127.986L9 12l-2.097 7h10.614l1.283-5.745c.913-4.088-1.386-8.21-5.267-9.445z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21a2 2 0 012-2h12a2 2 0 012 2v1H4v-1z"
  }));
};

Chess.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Chess.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TrashCan = function TrashCan(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TrashCan"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6h16l-1.58 14.22A2 2 0 0116.432 22H7.568a2 2 0 01-1.988-1.78L4 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.345 3.147A2 2 0 019.154 2h5.692a2 2 0 011.81 1.147L18 6H6l1.345-2.853z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6h20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11v5"
  }));
};

TrashCan.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TrashCan.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Microphone = function Microphone(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Microphone"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "8",
    y: "2",
    width: "8",
    height: "13",
    rx: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16.292A7.98 7.98 0 0112 19a7.98 7.98 0 01-6-2.708"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 22h4"
  }));
};

Microphone.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Microphone.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Coffee = function Coffee(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Coffee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.015c.328-.01.661-.015 1-.015 4.418 0 8 .895 8 2s-3.582 2-8 2-8-.895-8-2c0-.357.375-.693 1.033-.984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9v9.343c0 1.061.44 2.08 1.409 2.513C5.624 21.399 7.711 22 11 22c3.29 0 5.377-.601 6.591-1.144.968-.433 1.409-1.452 1.409-2.513V9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10v0a3 3 0 013 3v0a3 3 0 01-3 3v0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4v3"
  }));
};

Coffee.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Coffee.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CreditCard = function CreditCard(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "CreditCard"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "4",
    width: "20",
    height: "16",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.016A2.794 2.794 0 009.857 9C8.28 9 7 10.343 7 12s1.28 3 2.857 3c.854 0 1.62-.393 2.143-1.016M17 12c0 1.657-1.28 3-2.857 3-1.578 0-2.857-1.343-2.857-3s1.279-3 2.857-3C15.72 9 17 10.343 17 12z"
  }));
};

CreditCard.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CreditCard.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Utensils = function Utensils(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Utensils"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8V2H2v6a4 4 0 004 4h1a4 4 0 004-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16V2h3a4 4 0 014 4v10h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16v5a1 1 0 001 1h1a1 1 0 001-1v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16v5a1 1 0 001 1h1a1 1 0 001-1v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6V2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6V2"
  }));
};

Utensils.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Utensils.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Radish = function Radish(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Radish"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10H8c-2.188 0-3.698 1.415-3.935 3.282-.325 2.56.529 4.105 3.634 5.128 1.394.46 2.579 1.464 3.01 2.868l.223.722.095-.082a8 8 0 012.175-1.331l1.921-.789c3.286-1.348 5.22-3.408 4.826-6.516C19.712 11.415 18.188 10 16 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.964 6.97s-3.075.306-4.685-1.035C5.669 4.593 6.036 2.03 6.036 2.03s3.075-.306 4.686 1.035c1.61 1.342 1.242 3.905 1.242 3.905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.036 6.97s3.075.306 4.685-1.035c1.61-1.342 1.243-3.905 1.243-3.905s-3.075-.306-4.685 1.035c-1.61 1.342-1.243 3.905-1.243 3.905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11.5c-.5 1-3.134 1.5-7 1.5s-6.5-.5-7-1.5"
  }));
};

Radish.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Radish.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Clipboard = function Clipboard(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Clipboard"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4h4a1 1 0 011 1v15a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5a3 3 0 013-3v0a3 3 0 013 3v1H9V5z"
  }));
};

Clipboard.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Clipboard.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Bicycle = function Bicycle(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Bicycle"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "15",
    r: "4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "15",
    r: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15l2-7h7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15L15 5h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5h.5A1.5 1.5 0 0121 6.5v0A1.5 1.5 0 0119.5 8H19"
  }));
};

Bicycle.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Bicycle.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Plane = function Plane(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Plane"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11l-2 4 3.408 1.363a4 4 0 012.229 2.229L9 22l4-2-1.21-2.42a2 2 0 01.679-2.56L14 14l4 7 3-4-2.29-7.469.715-.714c1.412-1.412 2.71-3.682 1.075-5.317-1.635-1.635-3.91-.34-5.316 1.077l-.72.708L7 3 3 6l7 4-1.02 1.531a2 2 0 01-2.56.68L4 11z"
  }));
};

Plane.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Plane.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Jar = function Jar(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Jar"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9l1.164 8.926a3.875 3.875 0 002.844 3.243v0c3.27.872 6.713.872 9.984 0v0a3.875 3.875 0 002.844-3.243L21 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.035 7.266C3.763 7.661 3 8.165 3 8.714 3 9.977 7.03 11 12 11s9-1.023 9-2.286c0-.55-.764-1.054-2.037-1.448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4l-3 .51C4.159 4.874 3 5.407 3 6c0 1.105 4.03 2 9 2s9-.895 9-2c0-.592-1.159-1.125-3-1.49L15 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4v0a2 2 0 00-2-2h-2a2 2 0 00-2 2v0"
  }));
};

Jar.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Jar.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Glasses = function Glasses(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Glasses"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "14",
    r: "4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "14",
    r: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14l.211-.106a4 4 0 013.578 0L14 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6l2.838 6.623a2 2 0 01.162.788V14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6l-2.838 6.623A2 2 0 002 13.41V14"
  }));
};

Glasses.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Glasses.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Plant = function Plant(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Plant"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.964 6.97s-3.075.306-4.685-1.035C5.669 4.593 6.036 2.03 6.036 2.03s3.075-.306 4.686 1.035c1.61 1.342 1.242 3.905 1.242 3.905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.036 6.97s3.075.306 4.685-1.035c1.61-1.342 1.243-3.905 1.243-3.905s-3.075-.306-4.685 1.035c-1.61 1.342-1.243 3.905-1.243 3.905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14h14l-2 8H7l-2-8z"
  }));
};

Plant.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Plant.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Edit = function Edit(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Edit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.474 5.408l2.118 2.117m-.756-3.982L12.109 9.27a2.118 2.118 0 00-.58 1.082L11 13l2.648-.53c.41-.082.786-.283 1.082-.579l5.727-5.727a1.853 1.853 0 10-2.621-2.621z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 15v3a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h3"
  }));
};

Edit.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Edit.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TrashBin = function TrashBin(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "TrashBin"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4l2.303 14.076a4 4 0 002.738 3.167l.328.104a12 12 0 007.262 0l.328-.104a4 4 0 002.738-3.166L21 4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "12",
    cy: "4",
    rx: "9",
    ry: "2"
  }));
};

TrashBin.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TrashBin.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var SunFill = function SunFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "SunFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1a1 1 0 011 1v1a1 1 0 11-2 0V2a1 1 0 011-1zM3.293 3.293a1 1 0 011.414 0l1 1a1 1 0 01-1.414 1.414l-1-1a1 1 0 010-1.414zm17.414 0a1 1 0 010 1.414l-1 1a1 1 0 11-1.414-1.414l1-1a1 1 0 011.414 0zM12 7a5 5 0 100 10 5 5 0 000-10zM1 12a1 1 0 011-1h1a1 1 0 110 2H2a1 1 0 01-1-1zm19 0a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1zM4.293 18.293a1 1 0 011.414 1.414l-1 1a1 1 0 01-1.414-1.414l1-1zm15 2.414l-1-1a1 1 0 011.414-1.414l1 1a1 1 0 01-1.414 1.414zM12 20a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6a6 6 0 100 12 6 6 0 000-12z"
  }));
};

SunFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SunFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var MoonFill = function MoonFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "MoonFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.958 15.325c.204-.486-.379-.9-.868-.684a7.684 7.684 0 01-3.101.648c-4.185 0-7.577-3.324-7.577-7.425a7.28 7.28 0 011.134-3.91c.284-.448-.057-1.068-.577-.936C5.96 4.041 3 7.613 3 11.862 3 16.909 7.175 21 12.326 21c3.9 0 7.24-2.345 8.632-5.675z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.611 3.103c-.53-.354-1.162.278-.809.808l.63.945a2.332 2.332 0 010 2.588l-.63.945c-.353.53.28 1.162.81.808l.944-.63a2.332 2.332 0 012.588 0l.945.63c.53.354 1.162-.278.808-.808l-.63-.945a2.332 2.332 0 010-2.588l.63-.945c.354-.53-.278-1.162-.809-.808l-.944.63a2.332 2.332 0 01-2.588 0l-.945-.63z"
  }));
};

MoonFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
MoonFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var Person = function Person(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "Person"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "7",
    r: "5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14h.352a3 3 0 012.976 2.628l.391 3.124A2 2 0 0118.734 22H5.266a2 2 0 01-1.985-2.248l.39-3.124A3 3 0 016.649 14H7"
  }));
};

Person.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Person.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var PersonAdd = function PersonAdd(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "PersonAdd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "7",
    r: "5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22H5.266a2 2 0 01-1.985-2.248l.39-3.124A3 3 0 016.649 14H7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 13v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16h6"
  }));
};

PersonAdd.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
PersonAdd.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var PersonCheck = function PersonCheck(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "PersonCheck"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "7",
    r: "5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22H5.266a2 2 0 01-1.985-2.248l.39-3.124A3 3 0 016.649 14H7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16l2.25 2L22 14"
  }));
};

PersonCheck.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
PersonCheck.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var PersonCross = function PersonCross(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "PersonCross"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "7",
    r: "5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 22H5.266a2 2 0 01-1.985-2.248l.39-3.124A3 3 0 016.649 14H7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19l-5-5m5 0l-5 5"
  }));
};

PersonCross.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
PersonCross.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var FaceVeryHappy = function FaceVeryHappy(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "FaceVeryHappy"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.05v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.05v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18a4 4 0 004-4H8a4 4 0 004 4z"
  }));
};

FaceVeryHappy.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FaceVeryHappy.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var FaceHappy = function FaceHappy(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "FaceHappy"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.05v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.05v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14c-.5 1.5-1.79 3-4 3s-3.5-1.5-4-3"
  }));
};

FaceHappy.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FaceHappy.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var FaceNeutral = function FaceNeutral(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "FaceNeutral"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.05v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.05v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14h8"
  }));
};

FaceNeutral.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FaceNeutral.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var FaceSad = function FaceSad(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "FaceSad"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.05v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.05v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16c-.5-1.5-1.79-3-4-3s-3.5 1.5-4 3"
  }));
};

FaceSad.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FaceSad.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var FaceVerySad = function FaceVerySad(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "FaceVerySad"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.05v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.05v-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13a4 4 0 014 4H8a4 4 0 014-4z"
  }));
};

FaceVerySad.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FaceVerySad.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ThumbsUp = function ThumbsUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ThumbsUp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.605 5.782l.23-2.369c.091-.952.98-1.598 1.878-1.366 1.351.35 2.3 1.605 2.3 3.044v3.035c0 .675 0 1.013.146 1.26.083.141.197.26.333.345.24.151.567.151 1.22.151h.396c1.703 0 2.554 0 3.078.39.393.293.67.722.78 1.208.146.65-.181 1.463-.836 3.087l-.326.81a3.261 3.261 0 00-.226 1.48c.232 2.874-2.047 5.295-4.833 5.136l-10.424-.599c-1.139-.065-1.708-.098-2.222-.553-.515-.455-.612-.924-.805-1.861a14.324 14.324 0 01.055-6.037c.283-1.248 1.475-1.92 2.706-1.76 3.264.42 6.223-2.019 6.55-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5l-.137.457A14.983 14.983 0 007 21"
  }));
};

ThumbsUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ThumbsUp.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var ThumbsDown = function ThumbsDown(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "ThumbsDown"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.395 18.218l-.23 2.369c-.091.952-.98 1.598-1.878 1.366-1.351-.35-2.3-1.605-2.3-3.044v-3.035c0-.675 0-1.013-.146-1.26a1.018 1.018 0 00-.333-.345c-.24-.151-.567-.151-1.22-.151h-.396c-1.703 0-2.554 0-3.078-.39a2.073 2.073 0 01-.78-1.208c-.146-.65.181-1.463.836-3.087l.327-.81c.188-.468.265-.975.225-1.48-.232-2.874 2.047-5.295 4.833-5.135l10.424.598c1.139.065 1.708.098 2.222.553.515.455.612.924.805 1.861a14.317 14.317 0 01-.055 6.037c-.283 1.248-1.475 1.92-2.706 1.76-3.264-.42-6.223 2.019-6.55 5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12.5l.137-.457c.887-2.956.84-6.115-.137-9.043"
  }));
};

ThumbsDown.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ThumbsDown.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var VictoryHand = function VictoryHand(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "VictoryHand"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11l-1-7.272c0-.466.185-.913.515-1.243 1.024-1.024 2.777-.44 2.982.994L16 10l1.508-6.328a1.682 1.682 0 013.276.73L19 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16c-.536 4-3.358 6-7.5 6C7.358 22 4 20 4 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v-4a2 2 0 114 0m4 1v-2a2 2 0 10-4 0v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.692 17H11a2 2 0 110-4h4c2.21 0 4.5 2 3.5 5"
  }));
};

VictoryHand.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
VictoryHand.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var PointingUp = function PointingUp(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "PointingUp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16l.87-11.735a2.102 2.102 0 00-4.181-.433L15 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15v-3a2 2 0 10-4 0v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13v-1.5a2 2 0 10-4 0V15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13v-2a2 2 0 10-4 0v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16c-.536 4-3.358 6-7.5 6C7.358 22 4 20 4 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.692 17H11a2 2 0 110-4h4c2.21 0 4.5 2 3.5 5"
  }));
};

PointingUp.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
PointingUp.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var RockOn = function RockOn(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, otherProps, {
    id: "RockOn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16l.87-11.735a2.102 2.102 0 00-4.181-.433L15 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11l-.713-4.279a2.06 2.06 0 00-4.083.525L4 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13v-1.5a2 2 0 10-4 0V15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13v-2a2 2 0 10-4 0v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16c-.536 4-3.358 6-7.5 6C7.358 22 4 20 4 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.692 17H11a2 2 0 110-4h4c2.21 0 4.5 2 3.5 5"
  }));
};

RockOn.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
RockOn.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var FacebookFill = function FacebookFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "FacebookFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.067C0 18.033 4.333 22.994 10 24v-8.667H7V12h3V9.333c0-3 1.933-4.666 4.667-4.666.866 0 1.8.133 2.666.266V8H15.8c-1.467 0-1.8.733-1.8 1.667V12h3.2l-.533 3.333H14V24c5.667-1.006 10-5.966 10-11.933C24 5.43 18.6 0 12 0S0 5.43 0 12.067z"
  }));
};

FacebookFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FacebookFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TwitterFill = function TwitterFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "TwitterFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.643 4.937c-.835.37-1.732.62-2.675.733a4.67 4.67 0 002.048-2.578 9.3 9.3 0 01-2.958 1.13 4.66 4.66 0 00-7.938 4.25 13.229 13.229 0 01-9.602-4.868c-.4.69-.63 1.49-.63 2.342A4.66 4.66 0 003.96 9.824a4.647 4.647 0 01-2.11-.583v.06a4.66 4.66 0 003.737 4.568 4.692 4.692 0 01-2.104.08 4.661 4.661 0 004.352 3.234 9.348 9.348 0 01-5.786 1.995 9.5 9.5 0 01-1.112-.065 13.175 13.175 0 007.14 2.093c8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602a9.47 9.47 0 002.323-2.41l.002-.003z"
  }));
};

TwitterFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TwitterFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var LinkedInFill = function LinkedInFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "LinkedInFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.838A1.838 1.838 0 012.838 1H21.16A1.837 1.837 0 0123 2.838V21.16A1.838 1.838 0 0121.161 23H2.838A1.838 1.838 0 011 21.161V2.838zm8.708 6.55h2.979v1.496c.43-.86 1.53-1.634 3.183-1.634 3.169 0 3.92 1.713 3.92 4.856v5.822h-3.207v-5.106c0-1.79-.43-2.8-1.522-2.8-1.515 0-2.145 1.089-2.145 2.8v5.106H9.708V9.388zm-5.5 10.403h3.208V9.25H4.208v10.54zM7.875 5.812a2.063 2.063 0 11-4.125 0 2.063 2.063 0 014.125 0z"
  }));
};

LinkedInFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
LinkedInFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var DribbbleFill = function DribbbleFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "DribbbleFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.375 0 0 5.375 0 12s5.375 12 12 12c6.612 0 12-5.375 12-12S18.612 0 12 0zm7.926 5.531a10.202 10.202 0 012.317 6.378c-.338-.065-3.722-.755-7.132-.325-.079-.17-.144-.352-.222-.534a30.53 30.53 0 00-.676-1.484c3.774-1.536 5.492-3.748 5.713-4.035zM12 1.771c2.603 0 4.985.975 6.794 2.576-.182.26-1.731 2.33-5.375 3.696-1.68-3.084-3.54-5.61-3.827-6A10.424 10.424 0 0112 1.77zm-4.36.962c.273.365 2.095 2.903 3.8 5.922-4.79 1.276-9.02 1.25-9.475 1.25.664-3.176 2.812-5.818 5.675-7.172zm-5.896 9.28v-.312c.443.013 5.414.078 10.53-1.458.299.573.572 1.158.832 1.744-.13.039-.273.078-.403.117-5.284 1.705-8.096 6.364-8.33 6.755a10.226 10.226 0 01-2.629-6.846zM12 22.256c-2.369 0-4.555-.807-6.286-2.16.182-.378 2.264-4.387 8.043-6.404.026-.013.04-.013.065-.026 1.445 3.735 2.03 6.872 2.187 7.77-1.237.534-2.59.82-4.009.82zm5.714-1.757c-.104-.625-.651-3.618-1.992-7.302 3.215-.507 6.026.326 6.378.443-.443 2.85-2.083 5.31-4.386 6.859z"
  }));
};

DribbbleFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
DribbbleFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var RedditFill = function RedditFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "RedditFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-4.312-.942c.194.277.304.604.316.942a1.751 1.751 0 01-.972 1.596c.014.176.014.352 0 .528 0 2.688-3.132 4.872-6.996 4.872-3.864 0-6.996-2.184-6.996-4.872a3.444 3.444 0 010-.528 1.75 1.75 0 111.932-2.868 8.568 8.568 0 014.68-1.476l.888-4.164a.372.372 0 01.444-.288l2.94.588a1.2 1.2 0 11-.156.732L13.2 5.58l-.78 3.744a8.544 8.544 0 014.62 1.476 1.751 1.751 0 012.648.258zM8.206 12.533a1.2 1.2 0 101.996 1.334 1.2 1.2 0 00-1.996-1.334zm3.806 4.891c1.065.044 2.113-.234 2.964-.876a.335.335 0 10-.468-.48A3.936 3.936 0 0112 16.8a3.924 3.924 0 01-2.496-.756.324.324 0 00-.456.456 4.608 4.608 0 002.964.924zm2.081-3.178c.198.132.418.25.655.25a1.199 1.199 0 001.212-1.248 1.2 1.2 0 10-1.867.998z"
  }));
};

RedditFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
RedditFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TumblrFill = function TumblrFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "TumblrFill"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.895 22.517c-.798.867-2.646 1.456-4.301 1.483h-.182c-5.557 0-6.766-4.164-6.766-6.594v-6.748H5.458a.454.454 0 01-.324-.137.472.472 0 01-.134-.33V7.003c0-.164.05-.324.142-.458a.782.782 0 01.376-.29c2.855-1.026 3.748-3.562 3.87-5.49.035-.516.297-.765.738-.765H13.4a.451.451 0 01.33.134.468.468 0 01.137.333V5.87h3.823c.121 0 .238.05.324.137a.472.472 0 01.134.33v3.83a.472.472 0 01-.134.33.454.454 0 01-.324.138h-3.84v6.245c0 1.568 1.015 2.001 1.64 2.001a4.537 4.537 0 001.488-.321.973.973 0 01.595-.106.483.483 0 01.34.37l1.012 3.014c.068.237.14.498-.03.68z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }))));
};

TumblrFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TumblrFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var PinterestFill = function PinterestFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "PinterestFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12c0 5.123 3.211 9.497 7.73 11.218-.11-.937-.227-2.482.025-3.566.217-.932 1.401-5.938 1.401-5.938s-.357-.715-.357-1.774c0-1.66.962-2.9 2.161-2.9 1.02 0 1.512.765 1.512 1.682 0 1.025-.653 2.557-.99 3.978-.281 1.189.597 2.159 1.769 2.159 2.123 0 3.756-2.239 3.756-5.471 0-2.861-2.056-4.86-4.991-4.86-3.398 0-5.393 2.549-5.393 5.184 0 1.027.395 2.127.889 2.726a.36.36 0 01.083.343c-.091.378-.293 1.189-.332 1.355-.053.218-.173.265-.4.159-1.492-.694-2.424-2.875-2.424-4.627 0-3.769 2.737-7.229 7.892-7.229 4.144 0 7.365 2.953 7.365 6.899 0 4.117-2.595 7.431-6.199 7.431-1.211 0-2.348-.63-2.738-1.373 0 0-.599 2.282-.744 2.84-.282 1.084-1.064 2.456-1.549 3.235C9.584 23.815 10.77 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12z"
  }));
};

PinterestFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
PinterestFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var VkFill = function VkFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "VkFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.45 5.948c.166-.546 0-.948-.795-.948H20.03c-.668 0-.976.347-1.143.73 0 0-1.335 3.196-3.226 5.272-.612.602-.89.793-1.224.793-.167 0-.418-.191-.418-.738V5.948c0-.656-.184-.948-.74-.948H9.151c-.417 0-.668.304-.668.593 0 .621.946.765 1.043 2.513v3.798c0 .833-.153.984-.487.984-.89 0-3.055-3.211-4.34-6.885C4.45 5.288 4.198 5 3.527 5H.9c-.75 0-.9.347-.9.73 0 .682.89 4.07 4.145 8.551C6.315 17.341 9.37 19 12.153 19c1.669 0 1.875-.368 1.875-1.003v-2.313c0-.737.158-.884.687-.884.39 0 1.057.192 2.615 1.667C19.11 18.216 19.403 19 20.405 19h2.625c.75 0 1.126-.368.91-1.096-.238-.724-1.088-1.775-2.215-3.022-.612-.71-1.53-1.475-1.809-1.858-.389-.491-.278-.71 0-1.147 0 0 3.2-4.426 3.533-5.929z"
  }));
};

VkFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
VkFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var YoutubeFill = function YoutubeFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "YoutubeFill"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 6.507a2.786 2.786 0 00-.766-1.27 3.05 3.05 0 00-1.338-.742C19.518 4 11.994 4 11.994 4a76.624 76.624 0 00-9.39.47 3.16 3.16 0 00-1.338.76c-.37.356-.638.795-.778 1.276A29.09 29.09 0 000 12c-.012 1.841.151 3.68.488 5.494.137.479.404.916.775 1.269.371.353.833.608 1.341.743 1.903.494 9.39.494 9.39.494a76.8 76.8 0 009.402-.47 3.05 3.05 0 001.338-.742c.37-.353.633-.792.765-1.27A28.38 28.38 0 0024 12.023a26.579 26.579 0 00-.5-5.517zM9.602 15.424V8.577l6.26 3.424-6.26 3.423z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }))));
};

YoutubeFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
YoutubeFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var InstagramFill = function InstagramFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "InstagramFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.465 1.066C8.638 1.012 9.012 1 12 1c2.988 0 3.362.013 4.534.066 1.172.053 1.972.24 2.672.511.733.277 1.398.71 1.948 1.27.56.549.992 1.213 1.268 1.947.272.7.458 1.5.512 2.67C22.988 8.639 23 9.013 23 12c0 2.988-.013 3.362-.066 4.535-.053 1.17-.24 1.97-.512 2.67a5.396 5.396 0 01-1.268 1.949c-.55.56-1.215.992-1.948 1.268-.7.272-1.5.458-2.67.512-1.174.054-1.548.066-4.536.066-2.988 0-3.362-.013-4.535-.066-1.17-.053-1.97-.24-2.67-.512a5.397 5.397 0 01-1.949-1.268 5.392 5.392 0 01-1.269-1.948c-.271-.7-.457-1.5-.511-2.67C1.012 15.361 1 14.987 1 12c0-2.988.013-3.362.066-4.534.053-1.172.24-1.972.511-2.672a5.396 5.396 0 011.27-1.948 5.392 5.392 0 011.947-1.269c.7-.271 1.5-.457 2.67-.511zm8.98 1.98c-1.16-.053-1.508-.064-4.445-.064-2.937 0-3.285.011-4.445.064-1.073.049-1.655.228-2.043.379-.513.2-.88.437-1.265.822a3.412 3.412 0 00-.822 1.265c-.151.388-.33.97-.379 2.043-.053 1.16-.064 1.508-.064 4.445 0 2.937.011 3.285.064 4.445.049 1.073.228 1.655.379 2.043.176.477.457.91.822 1.265.355.365.788.646 1.265.822.388.151.97.33 2.043.379 1.16.053 1.507.064 4.445.064 2.938 0 3.285-.011 4.445-.064 1.073-.049 1.655-.228 2.043-.379.513-.2.88-.437 1.265-.822.365-.355.646-.788.822-1.265.151-.388.33-.97.379-2.043.053-1.16.064-1.508.064-4.445 0-2.937-.011-3.285-.064-4.445-.049-1.073-.228-1.655-.379-2.043-.2-.513-.437-.88-.822-1.265a3.413 3.413 0 00-1.265-.822c-.388-.151-.97-.33-2.043-.379zm-5.85 12.345a3.669 3.669 0 004-5.986 3.67 3.67 0 10-4 5.986zM8.002 8.002a5.654 5.654 0 117.996 7.996 5.654 5.654 0 01-7.996-7.996zm10.906-.814a1.337 1.337 0 10-1.89-1.89 1.337 1.337 0 001.89 1.89z"
  }));
};

InstagramFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
InstagramFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var FigmaFill = function FigmaFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "FigmaFill"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.415 0C5.968 0 4 2.053 4 4.568c0 1.529.728 2.887 1.847 3.716A4.613 4.613 0 004 12c0 1.53.728 2.887 1.847 3.716A4.613 4.613 0 004 19.432C4 21.947 5.968 24 8.415 24c2.446 0 4.415-2.053 4.415-4.568V15.57a4.307 4.307 0 002.755.999C18.032 16.568 20 14.515 20 12c0-1.53-.727-2.887-1.847-3.716A4.613 4.613 0 0020 4.568C20 2.053 18.032 0 15.585 0h-7.17zM5.659 4.568c0-1.591 1.242-2.865 2.756-2.865h2.755v5.73H8.415c-1.514 0-2.756-1.275-2.756-2.865zm9.926 2.864H12.83v-5.73h2.755c1.515 0 2.756 1.275 2.756 2.866 0 1.59-1.241 2.864-2.756 2.864zM5.66 12c0-1.59 1.242-2.865 2.756-2.865h2.755v5.73H8.415C6.9 14.865 5.659 13.59 5.659 12zm7.17 0c0-1.59 1.242-2.865 2.756-2.865 1.515 0 2.756 1.274 2.756 2.865 0 1.59-1.241 2.865-2.756 2.865-1.514 0-2.755-1.274-2.755-2.865zm-7.17 7.432c0-1.59 1.242-2.864 2.756-2.864h2.755v2.864c0 1.591-1.24 2.865-2.755 2.865-1.514 0-2.756-1.274-2.756-2.865z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }))));
};

FigmaFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
FigmaFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var GithubFill = function GithubFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "GithubFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"
  }));
};

GithubFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
GithubFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var TelegramFill = function TelegramFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "TelegramFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM12.43 8.859c-1.167.485-3.5 1.49-6.998 3.014-.568.226-.866.447-.893.663-.046.366.412.51 1.034.705.085.027.173.054.263.084.613.199 1.437.432 1.865.441.389.008.823-.152 1.302-.48 3.268-2.207 4.955-3.322 5.061-3.346.075-.017.179-.039.249.024.07.062.063.18.056.212-.046.193-1.84 1.862-2.77 2.726-.29.269-.495.46-.537.504-.094.097-.19.19-.282.279-.57.548-.996.96.024 1.632.49.323.882.59 1.273.856.427.291.853.581 1.405.943.14.092.274.187.405.28.497.355.944.673 1.496.623.32-.03.652-.331.82-1.23.397-2.126 1.179-6.73 1.36-8.628a2.111 2.111 0 00-.02-.472.506.506 0 00-.172-.325c-.143-.117-.365-.142-.465-.14-.451.008-1.143.249-4.476 1.635z"
  }));
};

TelegramFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
TelegramFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var DropboxFill = function DropboxFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "DropboxFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 2l6 3.75L6 9.5 0 5.75 6 2zm12 0l6 3.75-6 3.75-6-3.75L18 2zM0 13.25L6 9.5l6 3.75L6 17l-6-3.75zM18 9.5l6 3.75L18 17l-6-3.75 6-3.75zM6 18.25l6-3.75 6 3.75L12 22l-6-3.75z"
  }));
};

DropboxFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
DropboxFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var GoogleFill = function GoogleFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "GoogleFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.456 10.154c.123.659.19 1.348.19 2.067 0 5.624-3.764 9.623-9.449 9.623A9.841 9.841 0 012.353 12a9.841 9.841 0 019.844-9.844c2.658 0 4.879.978 6.583 2.566l-2.775 2.775V7.49c-1.033-.984-2.344-1.489-3.808-1.489-3.248 0-5.888 2.744-5.888 5.993 0 3.248 2.64 5.998 5.888 5.998 2.947 0 4.953-1.685 5.365-3.999h-5.365v-3.839h9.26z"
  }));
};

GoogleFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
GoogleFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var GoogleContainedFill = function GoogleContainedFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "GoogleContainedFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12c6.627 0 12-5.373 12-12S18.627 0 12 0zm.14 19.018c-3.868 0-7-3.14-7-7.018 0-3.878 3.132-7.018 7-7.018 1.89 0 3.47.697 4.682 1.829l-1.974 1.978v-.004c-.735-.702-1.667-1.062-2.708-1.062-2.31 0-4.187 1.956-4.187 4.273 0 2.315 1.877 4.277 4.187 4.277 2.096 0 3.522-1.202 3.816-2.852H12.14v-2.737h6.585c.088.47.135.96.135 1.474 0 4.01-2.677 6.86-6.72 6.86z"
  }));
};

GoogleContainedFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
GoogleContainedFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var AndroidFill = function AndroidFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "AndroidFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.532 15.106a1.003 1.003 0 11.001-2.007 1.003 1.003 0 010 2.007zm-11.044 0a1.003 1.003 0 11.001-2.007 1.003 1.003 0 010 2.007zm11.4-6.018l2.006-3.459a.413.413 0 10-.721-.407l-2.027 3.5a12.243 12.243 0 00-5.13-1.108c-1.85 0-3.595.398-5.141 1.098l-2.027-3.5a.413.413 0 10-.72.407l1.995 3.458C2.696 10.947.345 14.417 0 18.523h24c-.334-4.096-2.675-7.565-6.112-9.435z"
  }));
};

AndroidFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
AndroidFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var BitcoinFill = function BitcoinFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "BitcoinFill"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.385 15.275c1.111-.004 3.54-.013 3.512-1.558-.027-1.58-2.36-1.485-3.497-1.438-.127.005-.24.01-.332.011l.052 2.987c.075-.002.165-.002.265-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.267 10.922c.927-.001 2.95-.003 2.926-1.408-.026-1.437-1.969-1.352-2.918-1.31-.107.005-.2.009-.278.01l.047 2.709.223-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.096 23.641c6.43 1.603 12.942-2.31 14.545-8.738C25.244 8.474 21.33 1.962 14.9.36 8.474-1.244 1.962 2.67.36 9.1c-1.603 6.428 2.31 12.94 8.737 14.542zm4.282-17.02c1.754.124 3.15.638 3.333 2.242.136 1.174-.344 1.889-1.123 2.303 1.3.288 2.125 1.043 1.995 2.771-.161 2.145-1.748 2.748-4.026 2.918l.038 2.25-1.356.025-.039-2.22c-.351.006-.711.01-1.084.008l.04 2.23-1.356.024-.04-2.254-.383.003c-.194.001-.39.002-.586.006l-1.766.03.241-1.624s1.004-.002.986-.017c.384-.008.481-.285.502-.459L8.693 11.3l.097-.002h.046a1.101 1.101 0 00-.144-.007l-.044-2.54c-.057-.274-.241-.59-.79-.58.015-.02-.986.017-.986.017L6.846 6.74l1.872-.032v.007c.281-.005.57-.015.863-.026l-.038-2.229 1.356-.023.038 2.184c.362-.013.726-.027 1.083-.033l-.038-2.17 1.357-.024.039 2.229z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24"
  }))));
};

BitcoinFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
BitcoinFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var SpotifyFill = function SpotifyFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "SpotifyFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.995 0C5.381 0 0 5.382 0 11.996 0 18.616 5.381 24 11.995 24 18.615 24 24 18.615 24 11.996 24 5.382 18.615 0 11.995 0zM5.908 16.404a14.548 14.548 0 014.238-.638c2.414 0 4.797.612 6.892 1.77.125.068.238.292.29.572.05.28.03.567-.052.716a.61.61 0 01-.834.24A13.107 13.107 0 006.277 18.03a.61.61 0 01-.771-.402c-.107-.35.114-1.13.402-1.224zm-.523-4.42a18.154 18.154 0 014.76-.635c2.894 0 5.767.7 8.31 2.026.179.09.31.244.37.432a.747.747 0 01-.052.578c-.227.444-.493.743-.66.743a.769.769 0 01-.35-.086 16.33 16.33 0 00-7.617-1.854 16.34 16.34 0 00-4.366.585.749.749 0 01-.92-.525c-.112-.422.145-1.16.525-1.264zM5.25 9.098a.88.88 0 01-1.073-.641c-.123-.498.188-1.076.64-1.19a22.365 22.365 0 015.328-.649c3.45 0 6.756.776 9.824 2.307a.888.888 0 01.4 1.19c-.143.288-.453.598-.795.598a.924.924 0 01-.388-.087 20.026 20.026 0 00-9.041-2.126c-1.635 0-3.282.201-4.895.598z"
  }));
};

SpotifyFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SpotifyFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var SoundcloudFill = function SoundcloudFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "SoundcloudFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.16 16.466c.049 0 .09-.039.098-.093l.27-2.022-.27-2.069c-.007-.054-.05-.093-.099-.093-.05 0-.094.04-.1.093l-.236 2.069.236 2.021c.006.055.05.094.1.094z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.272 15.697c.048 0 .088-.036.095-.09l.209-1.256-.209-1.28c-.007-.053-.047-.09-.095-.09-.051 0-.09.037-.098.09L0 14.351l.174 1.256c.008.053.047.09.098.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.22 11.897a.122.122 0 00-.12-.114.12.12 0 00-.119.114l-.224 2.454.224 2.364a.12.12 0 00.12.112.121.121 0 00.12-.113l.254-2.363-.254-2.454z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.052 16.922a.143.143 0 00.14-.132l.241-2.439-.24-2.522a.143.143 0 00-.141-.132.14.14 0 00-.14.133l-.213 2.521.212 2.439a.14.14 0 00.141.133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01 16.962a.162.162 0 00.162-.152l.226-2.459-.226-2.34a.162.162 0 00-.162-.151.16.16 0 00-.16.152l-.2 2.34.2 2.458a.16.16 0 00.16.152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37 14.352l-.212-3.805a.184.184 0 00-.182-.173.183.183 0 00-.182.173l-.188 3.805.188 2.458a.183.183 0 00.364 0l.212-2.458z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.951 16.987a.201.201 0 00.201-.192v.002l.199-2.444-.199-4.676a.203.203 0 00-.405 0l-.174 4.676.175 2.443a.201.201 0 00.203.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.931 9.076a.222.222 0 00-.223.212l-.162 5.065.162 2.418a.221.221 0 00.223.211.22.22 0 00.223-.211l.185-2.418-.185-5.065a.22.22 0 00-.223-.212z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92 16.987a.24.24 0 00.244-.232v.002l.17-2.404-.17-5.235a.24.24 0 00-.243-.232.238.238 0 00-.243.232l-.153 5.235.153 2.404c.002.129.11.23.243.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.918 16.985a.26.26 0 00.263-.252v.002l.157-2.381-.157-5.103a.26.26 0 00-.263-.25.26.26 0 00-.264.25l-.138 5.103.139 2.38c.003.14.119.25.263.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.349 14.354l-.142-4.917a.28.28 0 00-.284-.27.28.28 0 00-.285.271l-.127 4.916.127 2.366a.28.28 0 00.285.27.28.28 0 00.284-.273v.003l.142-2.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.935 16.994c.165 0 .301-.13.304-.29l.129-2.349-.129-5.85a.301.301 0 00-.304-.291.303.303 0 00-.305.291l-.115 5.848.115 2.352c.003.158.14.289.305.289z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.944 7.664a.322.322 0 00-.327.31l-.133 6.382.134 2.315a.32.32 0 00.325.308.32.32 0 00.324-.311v.003l.146-2.315-.146-6.381a.32.32 0 00-.323-.311z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.866 16.996l8.181.004C22.678 17 24 15.732 24 14.167c0-1.564-1.322-2.832-2.953-2.832-.404 0-.79.079-1.142.22C19.672 9.003 17.44 7 14.718 7c-.665 0-1.314.126-1.887.339-.223.083-.283.168-.285.333v8.989a.349.349 0 00.32.335z"
  }));
};

SoundcloudFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SoundcloudFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

var CodepenFill = function CodepenFill(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ["color", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, otherProps, {
    id: "CodepenFill"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.372.19c.38-.253.875-.253 1.256 0L23.492 7.4c.317.21.508.565.508.946v7.308c0 .38-.19.736-.508.947l-10.864 7.21c-.38.252-.875.252-1.256 0L.508 16.6A1.136 1.136 0 010 15.654V8.346c0-.38.19-.736.508-.947L11.372.19zm-9.1 10.273v3.058l2.288-1.54-2.288-1.518zm4.337 2.878L3.18 15.648l7.684 5.1v-4.583L6.61 13.341zm6.527 2.824v4.582l7.684-5.1-3.43-2.306-4.254 2.824zm6.303-4.183l2.29 1.54v-3.06l-2.29 1.52zm1.371-3.636l-3.41 2.263-4.264-2.868V3.253l7.674 5.093zm-9.946-5.093V7.74l-4.263 2.868L3.19 8.346l7.674-5.093zM12 9.715l-3.35 2.254L12 14.192l3.35-2.223L12 9.715z"
  }));
};

CodepenFill.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
CodepenFill.defaultProps = {
  color: 'currentColor',
  size: '24',
  display: 'block'
};

exports.Air = Air;
exports.AirplayAudio = AirplayAudio;
exports.AirplayVideo = AirplayVideo;
exports.Airpods = Airpods;
exports.Alarm = Alarm;
exports.AlignBottom = AlignBottom;
exports.AlignHorizontalCenter = AlignHorizontalCenter;
exports.AlignLeft = AlignLeft;
exports.AlignRight = AlignRight;
exports.AlignToBottom = AlignToBottom;
exports.AlignToMiddle = AlignToMiddle;
exports.AlignToTop = AlignToTop;
exports.AlignTop = AlignTop;
exports.AlignVerticalCenter = AlignVerticalCenter;
exports.AndroidFill = AndroidFill;
exports.ArrowBack = ArrowBack;
exports.ArrowBackThick = ArrowBackThick;
exports.ArrowBackThickFill = ArrowBackThickFill;
exports.ArrowClockwise = ArrowClockwise;
exports.ArrowCounterClockwise = ArrowCounterClockwise;
exports.ArrowCycle = ArrowCycle;
exports.ArrowDown = ArrowDown;
exports.ArrowDownLeft = ArrowDownLeft;
exports.ArrowDownRight = ArrowDownRight;
exports.ArrowDownThick = ArrowDownThick;
exports.ArrowForward = ArrowForward;
exports.ArrowForwardThick = ArrowForwardThick;
exports.ArrowForwardThickFill = ArrowForwardThickFill;
exports.ArrowLeft = ArrowLeft;
exports.ArrowLeftThick = ArrowLeftThick;
exports.ArrowRight = ArrowRight;
exports.ArrowRightThick = ArrowRightThick;
exports.ArrowUp = ArrowUp;
exports.ArrowUpLeft = ArrowUpLeft;
exports.ArrowUpRight = ArrowUpRight;
exports.ArrowUpThick = ArrowUpThick;
exports.Attach = Attach;
exports.Backspace = Backspace;
exports.BackspaceFill = BackspaceFill;
exports.BatteryFull = BatteryFull;
exports.BatteryLow = BatteryLow;
exports.BatteryMedium = BatteryMedium;
exports.Bell = Bell;
exports.Bicycle = Bicycle;
exports.BitcoinFill = BitcoinFill;
exports.Block = Block;
exports.Bluetooth = Bluetooth;
exports.Book = Book;
exports.Bug = Bug;
exports.Calculator = Calculator;
exports.Calendar = Calendar;
exports.Camera = Camera;
exports.Check = Check;
exports.Chess = Chess;
exports.ChevronDown = ChevronDown;
exports.ChevronHorizontal = ChevronHorizontal;
exports.ChevronLeft = ChevronLeft;
exports.ChevronRight = ChevronRight;
exports.ChevronUp = ChevronUp;
exports.ChevronVertical = ChevronVertical;
exports.Circle = Circle;
exports.CircleAlert = CircleAlert;
exports.CircleCheck = CircleCheck;
exports.CircleChevronDown = CircleChevronDown;
exports.CircleChevronLeft = CircleChevronLeft;
exports.CircleChevronRight = CircleChevronRight;
exports.CircleChevronUp = CircleChevronUp;
exports.CircleFill = CircleFill;
exports.CircleMinus = CircleMinus;
exports.CirclePlus = CirclePlus;
exports.CircleTriangleDown = CircleTriangleDown;
exports.CircleTriangleLeft = CircleTriangleLeft;
exports.CircleTriangleRight = CircleTriangleRight;
exports.CircleTriangleUp = CircleTriangleUp;
exports.CircleX = CircleX;
exports.Clipboard = Clipboard;
exports.Cloud = Cloud;
exports.CloudDownload = CloudDownload;
exports.CloudUpload = CloudUpload;
exports.CodepenFill = CodepenFill;
exports.Coffee = Coffee;
exports.Coin = Coin;
exports.Command = Command;
exports.Comment = Comment;
exports.CommentAdd = CommentAdd;
exports.Computing = Computing;
exports.Copy = Copy;
exports.CreditCard = CreditCard;
exports.Cross = Cross;
exports.DesktopDevice = DesktopDevice;
exports.DoubleCheck = DoubleCheck;
exports.Download = Download;
exports.Draft = Draft;
exports.DribbbleFill = DribbbleFill;
exports.DropboxFill = DropboxFill;
exports.Edit = Edit;
exports.Enlarge = Enlarge;
exports.Envelope = Envelope;
exports.EyeClosed = EyeClosed;
exports.EyeOpen = EyeOpen;
exports.FaceHappy = FaceHappy;
exports.FaceNeutral = FaceNeutral;
exports.FaceSad = FaceSad;
exports.FaceVeryHappy = FaceVeryHappy;
exports.FaceVerySad = FaceVerySad;
exports.FacebookFill = FacebookFill;
exports.FigmaFill = FigmaFill;
exports.File = File;
exports.Fire = Fire;
exports.Flag = Flag;
exports.Flashlight = Flashlight;
exports.Folder = Folder;
exports.FolderAdd = FolderAdd;
exports.FullScreen = FullScreen;
exports.GameController = GameController;
exports.Gear = Gear;
exports.Gift = Gift;
exports.GithubFill = GithubFill;
exports.Glasses = Glasses;
exports.Globe = Globe;
exports.GoogleContainedFill = GoogleContainedFill;
exports.GoogleFill = GoogleFill;
exports.Grid = Grid;
exports.Hashtag = Hashtag;
exports.Headphone = Headphone;
exports.Health = Health;
exports.Heart = Heart;
exports.Height = Height;
exports.Home = Home;
exports.Image = Image;
exports.Inbox = Inbox;
exports.Infinity = Infinity;
exports.Info = Info;
exports.InstagramFill = InstagramFill;
exports.Jar = Jar;
exports.LaptopDevice = LaptopDevice;
exports.Leaf = Leaf;
exports.Lifesaver = Lifesaver;
exports.LightBulb = LightBulb;
exports.LinkChain = LinkChain;
exports.LinkOff = LinkOff;
exports.LinkOn = LinkOn;
exports.LinkOut = LinkOut;
exports.LinkedInFill = LinkedInFill;
exports.Location = Location;
exports.LockOff = LockOff;
exports.LockOn = LockOn;
exports.Map = Map;
exports.Mention = Mention;
exports.Microphone = Microphone;
exports.Miniplayer = Miniplayer;
exports.Minus = Minus;
exports.MobileDevice = MobileDevice;
exports.Money = Money;
exports.Moon = Moon;
exports.MoonFill = MoonFill;
exports.MoreHorizontal = MoreHorizontal;
exports.MoreVertical = MoreVertical;
exports.NormalScreen = NormalScreen;
exports.Paper = Paper;
exports.Pause = Pause;
exports.Pencil = Pencil;
exports.Person = Person;
exports.PersonAdd = PersonAdd;
exports.PersonCheck = PersonCheck;
exports.PersonCross = PersonCross;
exports.Phone = Phone;
exports.Pin = Pin;
exports.PinterestFill = PinterestFill;
exports.Plane = Plane;
exports.Planet = Planet;
exports.Plant = Plant;
exports.Play = Play;
exports.Plus = Plus;
exports.PointingUp = PointingUp;
exports.Question = Question;
exports.Radish = Radish;
exports.RedditFill = RedditFill;
exports.Reduce = Reduce;
exports.Ribbon = Ribbon;
exports.RockOn = RockOn;
exports.Rss = Rss;
exports.Schedule = Schedule;
exports.Scissor = Scissor;
exports.Search = Search;
exports.Send = Send;
exports.ShareBox = ShareBox;
exports.Shield = Shield;
exports.ShoppingBag = ShoppingBag;
exports.SignOut = SignOut;
exports.SoundDown = SoundDown;
exports.SoundOff = SoundOff;
exports.SoundOn = SoundOn;
exports.SoundUp = SoundUp;
exports.SoundcloudFill = SoundcloudFill;
exports.SpotifyFill = SpotifyFill;
exports.Star = Star;
exports.Stop = Stop;
exports.Sun = Sun;
exports.SunFill = SunFill;
exports.TabletDevice = TabletDevice;
exports.Tag = Tag;
exports.TelegramFill = TelegramFill;
exports.Telescope = Telescope;
exports.TextAlignCenter = TextAlignCenter;
exports.TextAlignJustified = TextAlignJustified;
exports.TextAlignLeft = TextAlignLeft;
exports.TextAlignRight = TextAlignRight;
exports.ThumbsDown = ThumbsDown;
exports.ThumbsUp = ThumbsUp;
exports.Thunder = Thunder;
exports.Ticket = Ticket;
exports.TrashBin = TrashBin;
exports.TrashCan = TrashCan;
exports.TriangleAlert = TriangleAlert;
exports.TriangleDown = TriangleDown;
exports.TriangleLeft = TriangleLeft;
exports.TriangleRight = TriangleRight;
exports.TriangleUp = TriangleUp;
exports.Trophy = Trophy;
exports.TumblrFill = TumblrFill;
exports.TwitterFill = TwitterFill;
exports.Utensils = Utensils;
exports.VictoryHand = VictoryHand;
exports.VkFill = VkFill;
exports.VrAr = VrAr;
exports.Wallet = Wallet;
exports.WatchDevice = WatchDevice;
exports.Water = Water;
exports.Width = Width;
exports.Wifi = Wifi;
exports.YoutubeFill = YoutubeFill;
exports.ZoomIn = ZoomIn;
exports.ZoomOut = ZoomOut;
